import { handleActions } from 'redux-actions';
import { SUCCESS, PENDING, FAILURE } from '../constants/store.constants';
import { GET_INVOICE_REQUEST, GET_INVOICE_FAILURE, GET_INVOICE_SUCCESS } from '../actions/invoice.action';
import { IInvoiceState } from './invoice.types';
import { defaultRequestStatus } from './fetch.types';

const defaultState: IInvoiceState = {
  invoice: null,
  invoiceRequest: defaultRequestStatus
};

const reduces = handleActions(
  {
    [GET_INVOICE_REQUEST]: () => ({
      ...defaultState,
      invoiceRequest: { status: PENDING, error: null }
    }),
    [GET_INVOICE_FAILURE]: action => ({
      ...defaultState,
      invoiceRequest: { status: FAILURE, error: action.payload }
    }),
    [GET_INVOICE_SUCCESS]: (state, action) => ({
      ...state,
      invoiceRequest: { status: SUCCESS, error: null },
      invoice: action.payload
    })
  },
  defaultState
);

export default reduces;
